import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import axios from "axios";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import ArgonDashboard from "./argon-dashboard";

// Configurar interceptor de axios para manejar respuestas 401 (Unauthenticated)
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && error.response.status === 401) {
      // Si la respuesta es 401 (Unauthenticated), hacer logout y redirigir al login
      try {
        await store.dispatch("auth/logout");
        // Redirigir al login si no estamos ya en esa ruta
        if (router.currentRoute.value.name !== "Login") {
          router.push({ name: "Login" });
        }
      } catch (logoutError) {
        console.error("Error al hacer logout:", logoutError);
        // Aún así redirigir al login
        if (router.currentRoute.value.name !== "Login") {
          router.push({ name: "Login" });
        }
      }
    }
    return Promise.reject(error);
  }
);

const appInstance = createApp(App);
appInstance.use(store);
appInstance.use(router);
appInstance.use(ArgonDashboard);
appInstance.config.globalProperties.$isDemo = process.env.VUE_APP_IS_DEMO || 0;
appInstance.mount("#app");
